import { BackgroundColors } from '@heartlandone/vega';
import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import dayjs from 'dayjs';

export const saveToLocalStorage = (key, data) => {
  const _ = JSON.stringify(data);
  localStorage.setItem(key, _);
}

export const loadFromLocalStorage = (key, _ = {}) => {
  return JSON.parse(localStorage.getItem(key)) || _;
}

export const saveToSessionStorage = (key, data) => {
  const _ = JSON.stringify(data);
  sessionStorage.setItem(key, _);
}

export const loadTokenfromSessionStorage = (key, data) => {
  const _token = (sessionStorage.getItem('token') || '');
  const hashIndex = _token.lastIndexOf('#/');
  return _token.substring(0, hashIndex < 0 ? Infinity : hashIndex);
}


export const RemoveFromSessionStorage = (key) => {
  sessionStorage.removeItem(key);
}

export const loadFromSesionStorage = (key, _ = {}) => {
  return JSON.parse(sessionStorage.getItem(key)) || _;
}

export const getQuerys = (querys = {}) => {
  const keys = Object.keys(querys);
 
  if (keys.length < 1) {
    return '';
  } else {
    return `?${new URLSearchParams(querys).toString()}`;
  }
}

export const getCategory = (category = 'registered', isGPActivities = false) => {
  return isGPActivities ? '' : `/${category}`;
}

export const getShortName = (str) => {
  return str?.split(' ').map((item) => {
    return item?.slice(0, 1).toUpperCase();
  }).join('');
}

export const getBackgroundByShortName = (str) => {
  if (str) {
    const letter2num = { a: 1, b: 2, c: 3, d: 4, e: 5, f: 6, g: 7, h: 8, i: 9, j: 10, k: 11, l: 12, m: 13, n: 14, o: 15, p: 16, q: 17, r: 18, s: 19, t: 20, u: 21, v: 22, w: 23, x: 24, y: 25, z: 26 };
    let total = 0;
    for (let index = 0; index < str.length; index++) {
      total += letter2num[str[index].toLowerCase()];
    }
    // use 40+ colors
    return BackgroundColors[total + 40];
  }
  return BackgroundColors[40];
}

let timeoutId = 0;
export const debounce = (cb, delay) => {
  
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    
    timeoutId = setTimeout(() => {
      console.info(timeoutId)
      cb(...args);
    }, delay);
  };
}

export const generateExcel = (data, {columns, expandRow, fileName}) => {
  const _workbook = new ExcelJS.Workbook();
  const _sheet1 = _workbook.addWorksheet("sheet1");
  _sheet1.columns = [
    ...columns,
  ];
  _sheet1.properties.defaultRowHeight = 22;
  _sheet1.views = [{
    state: 'frozen',
    xSplit: 0,
    ySplit: 1
  }];

  const borderStyle = {
    top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
    left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
    bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
    right: { style: 'thin', color: { argb: 'FFCCCCCC' } }
  };

  const headerStyle = {
    font: { bold: true, size: 14},
    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "" } },
    alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
    border: borderStyle
  };
  const dataCellStyle = {
    font: { size: 13 },
    alignment: { vertical: 'middle', wrapText: true },
    border: borderStyle
  };

  let rowNumber = 1;
  const headerRow = _sheet1.getRow(rowNumber);
  headerRow.eachCell((cell) => {
    Object.assign(cell, headerStyle);
  });
  data.forEach((item, index) => {
    _sheet1.addRow(item).eachCell((cell) => {
      Object.assign(cell, dataCellStyle);
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "" }
      }
    });
    rowNumber += 1;
    item?.[`${expandRow}`].forEach((r) => {
      _sheet1.addRow(r);
      rowNumber += 1;
    });
  });

  _workbook.xlsx.writeBuffer().then((buffer) => {
    let _file = new Blob([buffer], {
      type: "application/octet-stream",
    });
    FileSaver.saveAs(_file, `${fileName}.xlsx`);
  });
}

export const groupBy = (xs = [], key) => {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const isNumber = (value) => {
  if(value === '' || value === undefined || value === null) {
    return false;
  }
  return !isNaN(Number(value));
};

export const getTodayDateString = () => {
  const date = new Date();
  return date.toLocaleDateString();
}

export const formatActivityFormData = (formData) => {
  const formattedData = {...formData};
  formattedData.startTime = new Date(`${formattedData.activityStartDate} ${formattedData.activityStartTime}`).toISOString();
  formattedData.endTime = new Date(`${formattedData.activityEndDate} ${formattedData.activityEndTime}`).toISOString();
  formattedData.registerStartTime = new Date(`${formattedData.registerStartDate} ${formattedData.registerStartTime}`).toISOString();
  formattedData.registerDeadline = new Date(`${formattedData.registerEndDate} ${formattedData.registerEndTime}`).toISOString();
  formattedData.coverId = isNaN(formattedData.coverId) ? -1 : parseInt(formattedData.coverId, 10);
  formattedData.registerNumberLimit = parseInt(formattedData.registerNumberLimit, 10);
  formattedData.videoUrls = formattedData.videoUrls.filter((item) => item && item.trim() !== '');
  // formattedData.registerSetting = {};
  formattedData.registerSetting.isAllowInviteGuests = !!formattedData.registerSetting.isAllowInviteGuests;
  formattedData.registerSetting.maxInvitedGuests = isNaN(formattedData.registerSetting.maxInvitedGuests) ? 0 : parseInt(formattedData.registerSetting.maxInvitedGuests, 10);
  if (formattedData.receiverList && formattedData.receiverList.length > 0) {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const uuids = [];
    const emails = [];
    for (const item of formattedData.receiverList) {
      if (uuidRegex.test(item)) {
        uuids.push(item);
      } else if (emailRegex.test(item)) {
        emails.push(item);
      }
    }
    formattedData.groupIds = uuids;
    formattedData.recipientEmailAddresses = emails;
  }
  delete formattedData.receiverList;
  delete formattedData.activityStartDate;
  delete formattedData.activityStartTime;
  delete formattedData.activityEndDate;
  delete formattedData.activityEndTime;
  delete formattedData.registerStartDate;
  delete formattedData.registerEndDate;
  delete formattedData.registerEndTime;
  delete formattedData.maxInvitedGuests;
  delete formattedData.isAllowInviteGuests;
  delete formattedData.description;
  delete formattedData.fileLists;

  if (formattedData.roleId0) {
    const parsedData = [];
    for (let i = 0; ; i++) {
      const roleKey = `roleId${i}`;
      const numberKey = `numbers${i}`;
      if (!(roleKey in formattedData) || !(numberKey in formattedData)) {
        break;
      }
      parsedData.push({
        roleId: formattedData[roleKey],
        numbers: isNaN(formattedData[numberKey])? 0 : Number(formattedData[numberKey]),
      });
      delete formattedData.roleKey;
      delete formattedData.numberKey;
    }
    formattedData.activityAllowRoles = parsedData.filter(item => (item.roleId && item.roleId !== '' && Number(item.numbers) > 0));
  }
  if (formattedData.publisherCategory !== 'Company') {
    delete formattedData.activityAllowRoles;
  }

  if (!formattedData.isFree) {
    formattedData.chargeAmount = parseFloat(formattedData.chargeAmount);
    formattedData.chargeType = 'Paid';

  } else {
    formattedData.chargeAmount = 0;
    formattedData.chargeType = 'Unpaid';
  }
  let _imageIds = formattedData.imageIds.split('-');
  if(_imageIds.length === 1 && _imageIds[0] === '') {
    _imageIds = [];
  }
  formattedData.imageIds = _imageIds.map(id => parseInt(id, 10));

  let _documentIds = formattedData.documentIds.split('-');
  if(_documentIds.length === 1 && _documentIds[0] === '') {
    _documentIds = [];
  }
  formattedData.documentIds = _documentIds.map(id => parseInt(id, 10));
  delete formattedData.images;
  return formattedData;
}

export const formatActivityResponseData = (data) => {
  const activity = {...data};
  activity.activityStartDate = splitDateTimeWithDayjs(activity.startTime).date;
  activity.activityStartTime = splitDateTimeWithDayjs(activity.startTime).time;
  activity.activityEndDate = splitDateTimeWithDayjs(activity.endTime).date;
  activity.activityEndTime = splitDateTimeWithDayjs(activity.endTime).time;
  activity.registerStartDate = splitDateTimeWithDayjs(activity.registerStartTime).date;
  activity.registerStartTime = splitDateTimeWithDayjs(activity.registerStartTime).time;
  activity.registerEndDate = splitDateTimeWithDayjs(activity.registerDeadline).date;
  activity.registerEndTime = splitDateTimeWithDayjs(activity.registerDeadline).time;

  delete activity.startTime;
  delete activity.endTime;
  delete activity.registerDeadline;

  return activity;
}

export const isValidFile = (file, {
  ext = ['jpg', 'jpeg', 'png'],
  size = 4 * 1024 * 1024,
} = {}
) => {
  if (!file) return false;

  const isValidExt = ext.length === 0 || ext.includes(file.name.split('.').pop().toLowerCase());
  const isValidSize = file.size <= size;

  return isValidExt && isValidSize;
}

export const splitDateTimeWithDayjs = (timeString, dateFormat = 'YYYY-MM-DD', timeFormat = 'HH:mm') => {
  if (!timeString) return { date: '', time: '' };
  
  try {
    const dateTime = dayjs(timeString);
    
    return {
      date: dateTime.format(dateFormat),
      time: dateTime.format(timeFormat)
    };
  } catch (error) {
    console.error('Error parsing date with dayjs:', error);
    return { date: '', time: '' };
  }
};

export const isActivityFullyBooked = (activity) => {
  if (!activity) return false;

  const isWithinRegisterWindow = Date.now() < new Date(activity.registerDeadline).getTime();
  return (
    isWithinRegisterWindow &&
    activity.registerNumberLimitType === "Limited" &&
    activity.registerNumberLimit === activity.participantsCount
  );
};